<template>
  <!--
      作者：kmdshop
      时间：2020-06-01
      描述：插件中心-服务项目-添加
    -->
    <el-dialog
    title="添加设备套餐"
    :visible.sync="dialogVisible"
    @close="dialogFormVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :append-to-body="true" 
    width="50%"
  >

  <div class="product-add pb50">

    <el-form size="small" :model="form" ref="form" :rules="rules" label-width="100px">
      <el-form-item label="套餐名称" prop="name">
        <el-input v-model="form.name" placeholder="请输入套餐名称" class="max-w460"></el-input>
      </el-form-item>

      <el-form-item label="套餐封面" >
      <div class="d-c-c ad-picture" @click="openUpload">
        <img v-if="form.cover" :src="form.cover" width="124" height="124" />
        <span v-else class="el-icon-picture-outline"></span>
      </div>
    </el-form-item>



      <el-form-item label="套餐时间" prop="minute">
        <el-input v-model="form.minute" placeholder="请输入套餐时间" class="max-w460"></el-input>
        <span>分钟</span>
      </el-form-item>

      <el-form-item label="可申请退款时间" prop="min_minute">
        <el-input v-model="form.min_minute" placeholder="请输入可申请退款时间" class="max-w460"></el-input>
        <span>分钟</span>

        <div>注：使用少于多少分钟可申请退款</div>
      </el-form-item>

      <el-form-item label="套餐价格" prop="money">
        <el-input v-model="form.money" placeholder="请输入套餐价格" class="max-w460"></el-input>
        <span>元</span>
      </el-form-item>

      
      <el-form-item label="状态" prop="status">
      <div >
          <el-radio-group v-model="form.status">
            <el-radio  :label="1" >开启</el-radio>
            <el-radio  :label="0" >关闭</el-radio>
          </el-radio-group>
      </div>
      </el-form-item>

    
     
      <el-form-item label="排序" prop="sort"><el-input v-model="form.sort" placeholder="请输入排序" class="max-w460"></el-input></el-form-item>

    
      <!--提交-->
      <div class="common-button-wrapper">
        <el-button size="small" type="info" @click="cancelFunc">取消</el-button>
        <el-button size="small" type="primary" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
    </el-form>
  </div>
  <Upload v-if="isupload" :isupload="isupload" type="image" @returnImgs="returnImgsFunc">上传封面图片
    </Upload>
</el-dialog>
  
</template>

<script>
  import EquipApi from '@/api/equip.js';
import Upload from "@/components/file/Upload";
import draggable from "vuedraggable";
export default {
  components: {
    Upload,
    draggable
  },
  data() {
    return {
      /*form表单数据*/
      form: {
        name: '',
        images:[],
        minute:0,
        min_minute:0,
        status:0,
        money:0,
        sort:50,
        cover:"",
      },
      loading: false,
      /*验证规则*/
      rules: {
  
      },
      dialogVisible:false,
      isupload:false,

    };
  },
  created() {
    this.dialogVisible = this.open_add;
  },
  props: ["open_add",'equip_id'],
  methods: {
      /*获取图片*/
      returnImgsFunc(e) {
      if (e != null && e.length > 0) {
        this.form.cover = e[0].file_path;

      }
      this.isupload = false;
    },
    /*上传*/
    openUpload(e) {
      this.isupload = true;
    },


     /*关闭弹窗*/
     dialogFormVisible(result) {
      this.$emit("close", { openDialog: false,"type":result });
    },
    cancelFunc(){//取消
      this.dialogFormVisible("error")
    },

    onSubmit() {
      let self = this;
      let form = self.form;
      self.$refs.form.validate(valid => {
        if (valid) {
          self.loading = true;

         form.equip_id = self.equip_id;
         EquipApi.add_package(form, true)
            .then(data => {
              self.loading = false;
              self.$message({
                message: data.msg,
                type: 'success'
              });
              self.dialogFormVisible("error")
            })
            .catch(error => {
              self.loading = false;
            });
        }
      });
    },

    /*取消添加，返回任务列表*/
    cancelFunc() {
      this.$emit("close", { openDialog: false,"type":"" });
    }
  }
};
</script>

<style>
.edit_container {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.ql-editor {
  height: 400px;
}



.ql-editor {
  height: 400px;
}

.draggable-list {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
}

.draggable-list .wrapper > span {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .item {
  position: relative;
  width: 110px;
  height: 110px;
  margin-top: 10px;
  margin-right: 10px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #dddddd;
}

.draggable-list .delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: red;
  line-height: 16px;
  font-size: 16px;
  color: #ffffff;
  display: none;
}

.draggable-list .item:hover .delete-btn {
  display: block;
}

.draggable-list .item img {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  max-height: 100%;
  max-width: 100%;
}

.draggable-list .img-select {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #dddddd;
  font-size: 30px;
}

.draggable-list .img-select i {
  color: #409eff;
}

.video {
  width: 200px;
  height: 110px;
  margin-right: 10px;
}

.video video {
  margin-top: 10px;
  width: 100%;
  height: 100%;
}

.ad-picture {
  width: 110px;
  height: 110px;
  border-radius: 16px;
  font-size: 40px;
  border: 1px dashed #cccccc;
  color: $blue;
  cursor: pointer;
  overflow: hidden;
}
.ad-picture:hover {
  border: 1px dashed $blue;
}

.ad-picture img {
  object-fit: fill;
}
</style>



// WEBPACK FOOTER //
// src/views/plus/equip/equip/part/package/add.vue